import { useConsent } from "@/context/ConsentContext";
import { Button } from "@/components/ui/button";
import { Youtube } from "lucide-react";

// Blocca l'iframe di YouTube finché l'utente non autorizza i contenuti esterni.
export default function YouTubeGate({ youtubeId, title, playKey, startAt }) {
  const { has, grant } = useConsent();

  if (!youtubeId) return null;

  if (!has("youtube")) {
    return (
      <div
        className="aspect-video w-full rounded-sm overflow-hidden border border-border mb-4 bg-muted/60 flex items-center justify-center p-6"
        data-testid="youtube-gate"
      >
        <div className="max-w-md text-center">
          <Youtube className="h-8 w-8 text-primary mx-auto mb-3" />
          <p className="text-sm text-muted-foreground leading-relaxed mb-5">
            Questo video è ospitato da YouTube. Per visualizzarlo devi autorizzare i contenuti
            esterni, che potrebbero utilizzare cookie o altri strumenti di tracciamento.
          </p>
          <Button className="rounded-sm" onClick={() => grant("youtube")} data-testid="youtube-authorize-btn">
            Autorizza e guarda il video
          </Button>
        </div>
      </div>
    );
  }

  return (
    <div className="aspect-video w-full rounded-sm overflow-hidden border border-border mb-4 bg-black">
      <iframe
        key={playKey}
        data-testid="youtube-embed"
        className="w-full h-full"
        src={`https://www.youtube.com/embed/${youtubeId}?rel=0${startAt != null ? `&start=${startAt}&autoplay=1` : ""}`}
        title={title}
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
        allowFullScreen
      />
    </div>
  );
}
